import { createBuilderModule } from '../../../builder';
import { SectionName } from '../../../observability/tracking/events';
import { withTracking } from '../../../observability';
import { TestimonialCarousel } from './TestimonialCarousel';
import { COLOR_KEYS } from '../../../constants';
import { DEFAULT_VALUES } from './fixtures';
import { videoInputs } from '../../Video/Video.builder';

export default createBuilderModule(
  withTracking(TestimonialCarousel, {
    as: 'section',
    sectionName: SectionName.TestimonialCarousel,
  }),
  {
    name: 'TestimonialCarousel',
    image: 'https://pic.onlinewebfonts.com/svg/img_550787.png',
    inputs: [
      {
        name: 'testimonials',
        type: 'list',
        required: true,
        defaultValue: DEFAULT_VALUES.testimonials,
        subFields: [
          {
            name: 'quote',
            type: 'richText',
            required: true,
          },
          {
            name: 'author',
            type: 'string',
            required: true,
          },
          {
            name: 'company',
            type: 'string',
            required: true,
          },
          {
            name: 'hasAuthorAvatar',
            type: 'boolean',
          },
          {
            name: 'avatarUrl',
            type: 'cloudinaryImage',
          },
          {
            name: 'mediaURL',
            type: 'cloudinaryImage',
          },
          {
            name: 'mediaAltText',
            type: 'string',
          },
          {
            name: 'video',
            type: 'object',
            subFields: videoInputs,
          },
        ],
      },
      {
        name: 'backgroundColor',
        type: 'string',
        enum: [
          COLOR_KEYS.blue10,
          COLOR_KEYS.cream,
          COLOR_KEYS.neutral100,
          COLOR_KEYS.neutral200,
        ],
      },
    ],
  },
);
